import { createFileRoute } from '@tanstack/react-router';

import { TemplateDetailPage } from '@/features/templates/pages/TemplateDetailPage';

export const Route = createFileRoute('/_authenticated/templates/$templateId')({
  component: TemplateDetailPage,
  beforeLoad: () => ({
    breadcrumbs: [
      { href: '/templates', title: 'Templates' },
      { title: 'Template Detail' },
    ],
  }),
});
